export enum CalendarPostsSource {
    Suggested = 'suggested',
    Schedule = 'schedule',
    Deleted = 'deleted',
}